// extracted by mini-css-extract-plugin
export var root = "Splash-module--root--3rN-Y";
export var logo = "Splash-module--logo--J56Cd";
export var text = "Splash-module--text--23XA1";
export var outro = "Splash-module--outro--3rIUR";
export var align = "Splash-module--align--14Zbx";
export var space = "Splash-module--space--3s1wp";
export var scrollIndicator = "Splash-module--scrollIndicator--2I5OS";
export var indicateScroll = "Splash-module--indicateScroll--2nzf7";
export var server = "Splash-module--server--3ufGK";